//店铺接口
import axios from "./common.js";
import store from "../store/index";
import { Message } from "element-ui";
import { testR,officialId } from "./common";

//获取所有权限
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/permission/list
export const getMerchantPermissList = function() {
  /* return axios.post("v2/ePlatform/Service/Merchant/permission/list",{
    access_token:localStorage.getItem("access_token"),
    token_type:localStorage.getItem("token_type")
  })
 */
  return new Promise((resolve, reject) => {
    axios
      .post(`Merchant/v2/permission/list`, {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        merchant_id: localStorage.getItem("merchant_id")
      })
      .then(res => {
        if (testR(res)) {
          if (res.data.resp_data) {
            var t2 = [];
            var t4 = [];
            var t6 = [];
            // this.all_permission = res.data.resp_data;
            res.data.resp_data.forEach((item, index, arr) => {
              if (item.view_no.trim().length == 2) {
                t2.push({
                  id: item.permission_no.trim(),
                  label: item.permission_name,
                  view_no: item.view_no,
                  childList: []
                });
              } else if (item.view_no.trim().length == 4) {
                t4.push({
                  id: item.permission_no.trim(),
                  label: item.permission_name,
                  view_no: item.view_no,
                  childList: []
                });
              } else if (item.view_no.trim().length == 6) {
                t6.push({
                  id: item.permission_no.trim(),
                  view_no: item.view_no,
                  label: item.permission_name
                });
              }
            });
            // console.log(t2,t4,t6)

            for (let j = 0; j < t4.length; j++) {
              for (let i = 0; i < t6.length; i++) {
                if (t6[i].view_no.slice(0, 4) == t4[j].view_no.trim()) {
                  t4[j].childList.push(t6[i]);
                }
              }
            }
            for (let j = 0; j < t2.length; j++) {
              for (let i = 0; i < t4.length; i++) {
                if (t4[i].view_no.slice(0, 2) == t2[j].view_no.trim()) {
                  t2[j].childList.push(t4[i]);
                }
              }
            }
            // console.log(t2,t6)
            resolve({ t2, t6 });
          }
        }
      })
      .catch(e => {
        console.log(e);
        Message.error(e);
      });
  });
};

//
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/permission/listAccount
//TODO:

//Merchant/v2/permission/account/listAccount
/**
 * 获取所有授权过的用户
 * Merchant/v2/permission/account/listAccount
 * @returns  获取所有授权过的用户列表
 */
export const permissionListAccount = function() {
  return new Promise((resolve, reject) => {
    axios
      .post("Merchant/v2/permission/account/listAccount", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        merchant_id: localStorage.getItem("merchant_id")
      })
      .then(res => {
        /* console.log("获取授权用户接口：",res);
        resolve(res); */
        if (testR(res)) {
          let list = [];
          for (let i = 0; i < res.data.resp_data.length; i++) {
            list.push(res.data.resp_data[i]);
          }
          resolve(list);
        }
      })
      .catch(err => {
        Message.error(err);
      });
  });
};

/**操作员授权
 * Merchant/v2/permission/account/set
 * @param {*} account_id
 * @param {*} permission_no
 * @param {string} account_type mobile_no account_id
 * @returns
 */
export const setAccountPermissionASMerchant = function(
  account_id,
  permission_no,
  account_type
) {
  const data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    // [account_type]:account_id,
    account_id,
    account_type,
    permission:permission_no
  };

  return axios.post("Merchant/v2/permission/account/set", data).catch(err => {
    Message.error(err);
  });
};

/**删除操作员权限
 * Merchant/v2/permission/account/delete
 * @param {*} account_id
 * @param {*} permission_no
 * @returns
 */
export const delAccountPermissionASMerchant = function(
  account_id,
  permission_no
) {
  return axios
    .post("Merchant/v2/permission/account/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      account_id,
      permission_no
    })
    .catch(err => {
      Message.error(err);
    });
};

/**查询用户授权
 * Merchant/v2/permission/account/query
 * @param {*} account_id
 * @returns
 */
export const queryAccountPermissionASMerchant = function(account_id) {
  return axios
    .post("Merchant/v2/permission/account/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      account_id
    })
    .catch(err => {
      Message.error(err);
    });
};

/**获取所有用户组
 * merchant/v2/Usergroup/list
 * @returns
 */
export const MusergroupList = function() {
  return new Promise((resolve, reject) => {
    axios
      .post("merchant/v2/Usergroup/list", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        merchant_id: localStorage.getItem("merchant_id")
      })
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        }
      })
      .catch(e => {
        Message.error(e);
      });
  });
};

/**新增用户组
 * merchant/v2/Usergroup/generate
 * @param {*} data
 * @returns
 */
export const McreateUserGroup = function(data) {
  return axios
    .post("merchant/v2/Usergroup/generate", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      group_no: data.group_no,
      group_name: data.group_name,
      merchant_id: localStorage.getItem("merchant_id")
    })
    .catch(e => {
      Message.error(e);
    });
};

/**修改用户组
 * merchant/v2/Usergroup/modify
 * @param {*} data
 * @returns
 */
export const MmodifyUserGroup = function(data) {
  return axios
    .post("merchant/v2/Usergroup/modify", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id: data.group_id,
      group_no: data.group_no,
      group_name: data.group_name,
      flag: data.flag
    })
    .catch(e => {
      Message.error(e);
    });
};

/**给用户组授权
 * merchant/v2/usergroupPermission/set
 * @param {*} param0
 * @returns
 */
export const MsetUserGroupPermission = function({
  group_no,
  group_id,
  permission_no,
  description
}) {
  return axios
    .post("merchant/v2/usergroupPermission/set", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id,
      group_no,
      permission_no,
      description
    })
    .catch(e => {
      Message.error(e);
    });
};

/**删除用户组授权
 * merchant/v2/usergroupPermission/delete
 * @param {*} param0
 * @returns
 */
export const MdeleteUserGroupPermission = function({
  group_id,
  permission_no,
  group_no
}) {
  return axios
    .post("merchant/v2/usergroupPermission/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id,
      permission_no,
      group_no
    })
    .catch(e => {
      Message.error(e);
    });
};

/**删除用户组
 * merchant/v2/Usergroup/delete
 * @param {*} group_id
 * @returns
 */
export const MdeleteUsrGroup = function(group_id) {
  return axios
    .post("merchant/v2/Usergroup/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id
    })
    .catch(e => {
      Message.error(e);
    });
};

/**获取用户组权限
 * merchant/v2/usergroupPermission/query
 * @param {*} group_id
 * @returns
 */
export const MusergroupQuery = function(group_id) {
  return axios
    .post("merchant/v2/usergroupPermission/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      group_id
    })
    .catch(e => {
      Message.error(e);
    });
};

//TODO:
//店铺授权
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/permission/merchant/set
export const permissionMerchantSet = async function(mch_no, permission_no) {
  try {
    return await axios.post("Merchant/v2/permission/merchant/set", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      approve_mch_no: mch_no,
      merchant_id: localStorage.getItem("merchant_id"),
      mch_no: localStorage.getItem("merchant_id"),
      permission_no
    });
  } catch (e) {
    Message.error(e);
  }
};
//TODO:
//删除店铺权限
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/permission/merchant/delete
export const permissionMerchantDelete = async function(mch_no, permission_no) {
  try {
    return await axios.post("/Merchant/v2/permission/merchant/delete", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      approve_mch_no: mch_no,
      merchant_id: localStorage.getItem("merchant_id"),
      mch_no: localStorage.getItem("merchant_id"),
      permission_no
    });
  } catch (e) {
    Message.error(e);
  }
};
//TODO:
//查询店铺授权
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/permission/merchant/query
export const permissionMerchantQuery = async function(mch_no) {
  try {
    return await axios.post("/Merchant/v2/permission/merchant/query", {
      access_token: localStorage.getItem("access_token"),
      token_type: localStorage.getItem("token_type"),
      merchant_id: localStorage.getItem("merchant_id"),
      approve_mch_no: mch_no
    });
  } catch (e) {
    Message.error(e);
  }
};
//TODO:
//检索所有授权店铺
//http://test-api.hakspay.cn/v2/ePlatform/Service/Merchant/permission/merchant/listmerchant
export const permissionMerchantList = async function() {
  try {
    return new Promise((resolve, reject) => {
      axios
        .post("/merchant/v2/permission/merchant/listMerchant", {
          access_token: localStorage.getItem("access_token"),
          token_type: localStorage.getItem("token_type"),
          merchant_id: localStorage.getItem("merchant_id")
        })
        .then(res => {
          if (testR(res)) {
            let list = [];
            for (let i = 0; i < res.data.resp_data.length; i++) {
              list.push(res.data.resp_data[i]);
            }
            resolve(list);
          }
        })
        .catch(err => {
          Message.error(err);
        });
    });
    /* return await axios
      .post("v2/ePlatform/Service/Merchant/permission/merchant/delete", {
        access_token: localStorage.getItem("access_token"),
        token_type: localStorage.getItem("token_type"),
        mch_no:localStorage.getItem("merchant_id")
      }); */
  } catch (e) {
    Message.error(e);
  }
};

/**
 * 获取店铺信息
 * merchant/v2/common/query
 */
export const getMerchantInfo = function() {
  const data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id")
  };
  return axios.post("merchant/v2/common/query", data).catch(e => {
    Message.error(e);
  });
};

/**修改店铺信息
 * merchant/v2/common/modify
 * @param {*} info
 * @returns
 */
export const modifyMerchantInfo = function(info) {
  const data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    info
  };
  return axios.post("merchant/v2/common/modify", data).catch(e => {
    Message.error(e);
  });
};

/**注册打印模板
 *merchant/v2/print/register
 */
export const printRegister = function(obj, design) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    ...obj,
    design
  };
  return axios
    .post("merchant/v2/print/register", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**获取所有打印模板
 *merchant/v2/print/list
 */
export const getprintList = function() {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id")
  };
  return axios.post("merchant/v2/print/list", JSON.stringify(data)).catch(e => {
    Message.error(e);
  });
};

/**按模板号搜索模板
 * merchant/v2/print/query
 * @param {string} template_no 模板号
 * @returns json
 */
export const printQuery = function(template_no) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    template_no
  };
  return axios
    .post("merchant/v2/print/query", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**
 * merchant/v2/print/modify
 * @param {*} obj
 * @param {*} design
 * @returns
 */
export const printModify = function(obj, design) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    ...obj,
    design
  };
  console.log(JSON.stringify(data));
  return axios
    .post("merchant/v2/print/modify", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**
 * 获取所有打印机
 * merchant/v2/offlinestores/message
 *
 */
export const offlinestoresMessage = function() {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    url: "/common/ExService/ListPrinter"
  };
  return axios
    .post("merchant/v2/offlinestores/message", JSON.stringify(data))
    .catch(e => {
      Message.error(e);
    });
};

/**删除模板
 * merchant/v2/print/delete
 */
export const printDelete = function(template_no) {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id"),
    template_no
  };
  return axios.post("merchant/v2/print/delete", JSON.stringify(data));
};

/**
 * 获取所有线上类别
 */
export const classifyList = function() {
  var data = {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id")
  };
  return new Promise((resolve, reject) => {
    axios
      .post("/Merchant/v2/chain/classify/list", JSON.stringify(data))
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          reject(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};

//TODO: 这个appid 是测试版到时候需要改成正式版
/**
 * merchant/v2/common/Attention
 * 获取店铺关注链接
 */
export const getAttention = function() {
  return axios.get(
    `merchant/v2/common/Attention?mch_no=${localStorage.getItem("merchant_id")}&appid=wxf003ddc051b4643b`
  );
};


/**
 * 微信unionid换取openid
 */
 export const wxUnionIdToOpenId = function(union_id) {
	return axios.get(
		`Membership/v2/Account/unionToOpenID?appid=${officialId}&union_id=${union_id}`);
}
